import { instance4 } from "App/constants";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export const urlGet = LIST_URL_WAREHOUSE.daftarAdjustmentPBF.get;
export const urlDelete = LIST_URL_WAREHOUSE.daftarAdjustmentPBF.delete;

export const RESET_STATE_FORM_FILTER = {
  pages: 1,
  limit: 10,
  id: "",
  gudang: "Pilih Gudang",
  gudang_id: "",
  flag: 1,
  status: "",
  statusName: "Semua Status", 
};

export const deleteAdjusmentById = async (id) => {
  try {
    const api = await instance4.post(urlDelete, {
      id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        message: "Berhasil menghapus adjusment",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const getByFilterAdjusment = async (formFilter, pages, limit) => {
  try {
    const api = await instance4.post(urlGet, {
      halaman: pages,
      jumlah: limit,
      id: formFilter.id,
      gudang_id: formFilter.gudang_id,
      status: formFilter.status,
      flag: 1,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID ADJUSMENT",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "namaGudang",
    disablePadding: false,
    label: "GUDANG",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "status",
    disablePadding: false,
    label: "STATUS",
    align: "left",
  },
  {
    id: "createdAt",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "createdBy",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updatedAt",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updatedBy",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];
